"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCDownIcon16Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowCDownIcon16Regular = forwardRef_1.forwardRef('ArrowCDownIcon16Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.97 5.47a.75.75 0 0 1 1.06 0l3.793 3.793a.25.25 0 0 0 .354 0L11.97 5.47a.75.75 0 1 1 1.06 1.06l-3.793 3.793a1.75 1.75 0 0 1-2.474 0L2.97 6.53a.75.75 0 0 1 0-1.06Z" })));
});
